// 吉打州球场数据
// Kedah Golf Courses

export const KEDAH_COURSES = {
  "99_East_Golf_Club": {
    shortName: "99EGC",
    fullName: "99 East Golf Club",
    location: ["Langkawi", "Kedah", "Malaysia"],
    pars: [5,3,4,4,4,5,4,4,3],
    index: [4,8,5,9,1,2,6,3,7]
  },

  "BLACK_FOREST_GOLF_AND_COUNTRY_CLUB": {
    shortName: "BFGCC",
    fullName: "Black Forest Golf & Country Club",
    location: ["Bukit Kayu Hitam", "Kedah", "Malaysia"],
    pars: [4,5,3,4,4,5,3,4,4, 4,5,3,4,5,4,3,4,4],
    index: [11,7,17,5,1,9,15,3,13, 14,6,16,4,8,12,18,2,10]
  },

  "CINTA_SAYANG_GOLF_RESORT": {
    shortName: "CSGR",
    fullName: "Cinta Sayang Golf Resort",
    location: ["Sungai Petani", "Kedah", "Malaysia"],
    pars: [4,5,4,4,3,5,3,4,4, 4,4,5,3,5,4,3,4,4],
    index: [11,1,5,3,17,9,13,15,7, 4,14,6,8,2,16,18,12,10]
  },

  "DARULAMAN_GOLF_&_COUNTRY_CLUB": {
    shortName: "DGCC",
    fullName: "Darulaman Golf & Country Club",
    location: ["Jitra", "Kedah", "Malaysia"],
    pars: [5,4,3,4,5,3,4,4,4, 5,3,4,4,3,4,5,4,4],
    index: [9,5,11,13,1,17,15,7,3, 2,18,6,10,16,4,14,12,8]
  },

  "Gunung_Raya_Golf_Resort": {
    shortName: "GR",
    fullName: "Gunung Raya Golf Resort",
    location: ["Langkawi", "Kedah", "Malaysia"],
    pars: [4,5,4,3,4,4,3,5,4, 5,3,4,4,4,5,4,3,4],
    index: [11,5,7,13,3,17,9,15,1, 16,14,2,8,6,18,10,12,4]
  },

  "Harvard_Golf_&_Country_Club": {
    shortName: "HGCC",
    fullName: "Harvard Golf & Country Club",
    location: ["Gurun", "Kedah", "Malaysia"],
    pars: [4,3,5,3,4,4,4,4,5, 4,3,4,5,3,4,4,4,5],
    index: [7,15,5,9,1,3,11,17,13, 4,18,14,6,16,10,2,8,12]
  },

  "KELAB_GOLF_UNIVERSITI_UTARA_MALAYSIA": {
    shortName: "KGUUM",
    fullName: "Kelab Golf Universiti Utara Malaysia",
    location: ["Sintok", "Kedah", "Malaysia"],
    pars: [5,4,5,3,4,3,4,4,4, 3,4,4,4,5,5,3,4,4],
    index: [15,13,5,9,1,11,7,17,3, 18,10,4,2,14,8,12,6,16]
  },

  "KULIM_GOLF_AND_COUNTRY_RESORT": {
    shortName: "KGCR",
    fullName: "Kulim Golf & Country Resort",
    location: ["Kulim", "Kedah", "Malaysia"],
    pars: [4,4,3,5,4,4,3,5,4, 4,4,4,3,5,3,4,5,4],
    index: [13,3,17,11,9,1,5,7,15, 10,14,4,18,6,8,2,16,12]
  },

  "PERMAIPURA_GOLF_&_COUNTRY_CLUB": {
    shortName: "PGCC",
    fullName: "Permaipura Golf & Country Club",
    location: ["Bedong", "Kedah", "Malaysia"],
    pars: [4,4,3,4,5,3,5,4,4, 4,4,4,3,4,3,5,4,5],
    index: [7,5,17,15,3,9,1,13,11, 6,4,8,14,18,16,2,10,12]
  },

  "ROYAL_KEDAH_CLUB": {
    shortName: "RKC",
    fullName: "Royal Kedah Club",
    location: ["Alor Setar", "Kedah", "Malaysia"],
    pars: [4,5,4,3,4,5,3,4,4],
    index: [11,17,3,9,1,7,15,5,13]
  },

  "Sungai_Petani_Golf_Club": {
    shortName: "SPGC",
    fullName: "Sungai Petani Golf Club",
    location: ["Sungai Petani", "Kedah", "Malaysia"],
    pars: [3,5,3,4,4,4,4,4,4, 4,5,3,4,3,5,4,4,4],
    index: [1,3,5,7,9,11,13,15,17, 2,4,6,8,10,12,14,16,18]
  }
};

export default KEDAH_COURSES;
